import { get } from 'utils/axios';
import { GetExperienceRecommendationEndpoint } from '@kouto/types';
import { z } from 'zod';
import ApiResponse from '../types/ApiResponse';

export type GetListingRecommendationsResponse = z.infer<
  typeof GetExperienceRecommendationEndpoint.responseSchema
>;

const getListingRecommendations = async (url: string) => {
  const response = await get<ApiResponse<GetListingRecommendationsResponse>>(
    url,
  );
  return response.data;
};

export default getListingRecommendations;
